export const getFileIdentifier = (file) => file?.document_ulid || file?.file?.name || file?.name;

export const mergeUploadedFiles = (existingFiles, files) => {
    const mergedFiles = [...(existingFiles || [])];
    (files || []).forEach((file) => {
        const newIdentifier = getFileIdentifier(file);
        const alreadyPresent = mergedFiles.some((existingFile) => {
            const existingIdentifier = getFileIdentifier(existingFile);
            return existingIdentifier && newIdentifier && existingIdentifier === newIdentifier;
        });
        if (!alreadyPresent) {
            mergedFiles.push(file);
        }
    });
    return mergedFiles;
};

export const applyFocDocFieldError = (form, files) => {
    if (!files || files.length === 0) {
        form.setFieldError('foc_doc', 'Please upload at least one file');
        return;
    }
    form.setFieldError('foc_doc', undefined);
};
